import React, { type FC } from 'react'

const Spinner: FC = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"
    style={{ animation: "spin 0.7s linear infinite" }}>
    <path d="M12 2a10 10 0 0110 10" opacity="0.3"/>
    <path d="M12 2a10 10 0 0110 10"/>
    <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>
  </svg>
);

export default Spinner